import axiosRetry, { isNetworkError, isSafeRequestError } from "axios-retry";

// const IDEMPOTENT_HTTP_METHODS = [
//   "get",
//   "post",
//   "head",
//   "options",
//   "put",
//   "delete"
// ];

// function isIdempotentRequestError(error) {
//   if (!error.config?.method) {
//     // Cannot determine if the request can be retried
//     return false;
//   }
//   return (
//     isRetryableError(error) &&
//     IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1
//   );
// }

function isNetworkOrSafeRequestError(error) {
  return isNetworkError(error) || isSafeRequestError(error);
}

export default function (axiosInstance) {
  axiosRetry(axiosInstance, {
    retries: 3,
    timeout: 60* 1000,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: isNetworkOrSafeRequestError
  });

  return axiosInstance;
}
